import { supabase } from './supabaseClient'

export function minimumTrainingScheduleCount(weeklyCommitment: unknown): number {
  const commitment = typeof weeklyCommitment === 'number' ? weeklyCommitment : Number(weeklyCommitment)
  if (Number.isFinite(commitment) && commitment >= 2) {
    return Math.min(Math.max(2, Math.round(commitment)), 7)
  }
  return 2
}

/** True when the user has a usable post-onboarding protocol in the database. */
export async function protocolWasPersisted(weeklyCommitment?: unknown): Promise<boolean> {
  const minSchedules = minimumTrainingScheduleCount(weeklyCommitment)

  const [{ count: scheduleCount, error: scheduleError }, { count: mealCount, error: mealError }] =
    await Promise.all([
      supabase.from('training_schedules').select('id', { count: 'exact', head: true }),
      supabase.from('meal_protocols').select('id', { count: 'exact', head: true }),
    ])

  if (scheduleError || mealError) {
    console.warn('protocolWasPersisted check failed:', scheduleError?.message ?? mealError?.message)
    return false
  }

  return (scheduleCount ?? 0) >= minSchedules && (mealCount ?? 0) > 0
}

export async function countTrainingSchedules(): Promise<number> {
  const { count, error } = await supabase
    .from('training_schedules')
    .select('id', { count: 'exact', head: true })

  if (error) {
    console.warn('countTrainingSchedules failed:', error.message)
    return 0
  }

  return count ?? 0
}

export type EnsureProtocolResult = {
  ok: boolean
  error: string | null
  regenerated: boolean
}
